
<template>

	<div class="panel-body">

		<div class="col-xs-12" v-if="supervisorTerms">
			<div v-for="term in supervisorTerms">
				<h4 @click="selectedTerm === term.id ? selectedTerm = null : selectedTerm = term.id" class="cursor-pointer">
					{{term.name}}
					<i class="fa fa-caret-down" v-if="selectedTerm===term.id"></i>
                    <i v-else class="fa fa-caret-right"></i>
				</h4>
				<div v-if="selectedTerm === term.id">
					
					<table class="table table-striped table-bordered">
						<thead>
							<tr>
								<th>Name</th>
								<th>Date</th>
								<th v-if="term.type === 'intermediate' || term.type === 'advanced'">Path</th>
								<th>Description</th>
								<th>Online Only</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="event in term.events">
								<td>
									{{event.name}}
								</td>
								<td>
									{{eventDate({termStartDate: term.startDate, timeFromStart: event.timeFromStart, timeUnit:event.timeUnit, duration: event.duration})}}
								</td>
								<td v-if="term.type === 'intermediate' || term.type === 'advanced'">
									{{event.path}}
								</td>
								<td>
									{{event.description}}
								</td>
								<td>
									{{event.ignoreCampus ? 'Yes' : ''}}
								</td>
							</tr>
						</tbody>
						<tfoot>
						</tfoot>
					</table>
					
				</div>
			</div>
		</div>

	</div>


</template>

<script>

import journeys from './../../services/journeys';
import terms from './../../services/terms';

import moment from 'moment';

export default {
    data() {
        return {
        	supervisorTerms: null,
        	selectedTerm: null,
        }
    },
    components: {

    },
    created() {

    },
    async mounted() {
        let supervisorTerms = await terms.getSupervisorTerms(this);
        const now = new Date();

        this.supervisorTerms = supervisorTerms.data.terms.filter(t => new Date(t.startDate) < now && new Date(t.endDate) > now).map((t)=>{ t.events = []; return t;})

        if (this.supervisorTerms.length > 0) {
        	this.selectedTerm = this.supervisorTerms[0].id;
        }

    	journeys.getEvents(this).then((response)=>{
    		const events = response.data.events;
    		for (const term of this.supervisorTerms) {
    			let termEvents;
    			const isWinterTerm = new Date(term.startDate).getMonth() === 9;
    			if (isWinterTerm) {
    				termEvents = events.filter(e => e.termType === term.type);
    			} else {
    				termEvents = events.filter(e => e.termType === term.type && !e.name.toLowerCase().includes('winter '));
    			}

    			if (localStorage.path == '9200') {
    				termEvents = termEvents.filter(e => e.actionName !== 'pickPath');
    			}

    			term.events = termEvents.filter((e)=>{
		    			if (!e.name.includes('Summer ') && !e.name.includes('Winter ') && !e.name.includes('Spring ') ) {
		    				return true;
		    			}
		    			if (new Date(term.startDate).getMonth() === 9) {
		    				return e.name.includes('Winter ')
		    			}
		    			if (new Date(term.startDate).getMonth() === 5) {
		    				return e.name.includes('Summer ')
		    			}
		    			if (new Date(term.startDate).getMonth() === 1) {
		    				return e.name.includes('Spring ')
		    			}
		    		}).sort((a,b)=>{
	    				return a.timeFromStart - b.timeFromStart;
    			});


    		}

    	});
    },
    methods: {
    	eventDate({termStartDate, timeFromStart, timeUnit, duration }){
    		
    		let eventDates = '';
    		const startDate = moment(termStartDate).add(timeFromStart, timeUnit);

    		eventDates += startDate.format('MMM DD, YYYY');

    		if (duration && duration > 0) {
    			const endDate = startDate.clone().add(duration, timeUnit);
				eventDates += ' - ' + endDate.format('MMM DD, YYYY');
    		}

    		return eventDates;

    	}
    },
    computed: {

    }
}
</script>

<style lang="scss" scoped>

table {
	table-layout: fixed;
}

</style>


// WEBPACK FOOTER //
// SupervisorJourney.vue?1f144373